import {serviceAPI} from "./service"
import {GET_BALANCE_ON_ACCOUNT_URL, LIST_ACCOUNTS, SAVE_ACCOUNT, TOTAL_ACCOUNTS} from "../constants/url.constants"
import {handleErrorResponse} from "../actions/message"

export const loadAccountsList = (name) => {
    return serviceAPI
        .get(LIST_ACCOUNTS + "?name=" + name)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const totalAccounts = (name) => {
    return serviceAPI
        .get(TOTAL_ACCOUNTS + "?name=" + name)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const saveAccount = (data) => {
    return serviceAPI
        .post(SAVE_ACCOUNT, data)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}

export const getBalanceOnAccount = (accountId) => {
    return serviceAPI
        .get(GET_BALANCE_ON_ACCOUNT_URL + accountId)
        .then((response) => {
            return response.data
        }).catch(error => {
            handleErrorResponse(error)
        })
}